/**
 * en-GB messages added by Phase 2 task S18 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s18EnGB = {
    'nav.apiClients': 'Client API',
    'apiScope.visits.sign_in': 'Sign people in',
    'apiScope.visits.sign_out': 'Sign people out',
    'apiScope.visits.on_site': 'See who is on site',
    'apiScope.webhooks.test': 'Send itself a test webhook',
    'error.person_not_matched': 'That person could not be matched to a member. It is on the "needs matching" list.',
    'error.api_client_managed': 'This client is managed by another part of CloudSign and cannot be changed here.',
    'error.api_client_revoked': 'This client has been revoked.',
    'error.api_client_site_unknown': 'One of the sites does not exist.',
    'error.api_client_group_unknown': 'One of the groups does not exist.',
    'error.api_client_default_group': 'The default group must be one of the groups the client may use.',
    'error.external_link_conflict': 'That external id is already linked to something else.',
    'error.unmatched_no_external_id': 'This person was sent without an id from the other system, so it can only be dismissed.',
    'error.unmatched_member_not_current': 'Only a current member can be linked.',
};
//# sourceMappingURL=s18.js.map